import { useState } from "react";

// Component
import LimitedSearch from "../components/SearchResults/LimitedSearch";

function LimitedSelectApp() {
  const [hasSearchResults, setHasSearchResults] = useState(false);

  return (
    <div
      className="cpv-search-app-container"
      style={{ minHeight: hasSearchResults ? "450px" : "200px" }}
    >
      <div className="cpv-search-app-wrapper">
        <LimitedSearch
          setHasSearchResults={setHasSearchResults}
          type="limitedSelect"
        />
      </div>
    </div>
  );
}

export default LimitedSelectApp;
